/**
 * GuardianCompliancePage - Guardian compliance review dashboard
 *
 * Surfaces the ComplianceDashboard from @/guardian for compliance officers.
 * Provides guardian enrollment review, document verification, and compliance tracking.
 *
 * Route: /guardian/compliance
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconClipboardCheck } from '@tabler/icons-react';

import { ComplianceDashboard } from '@/guardian';
import { useAuth } from '@/auth/AuthContext';

export function GuardianCompliancePage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="yellow">
            <IconClipboardCheck size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Guardian Compliance</Title>
            <Text size="sm" c="dimmed">
              Guardian enrollment review, document verification, and compliance tracking
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ComplianceDashboard />
    </Container>
  );
}

export default GuardianCompliancePage;
